module.exports = __webpack_public_path__ + "img/head_ai.205cec2d.png";